// extracted by mini-css-extract-plugin
module.exports =  {"svgSpin":"svgSpin_m6jCjB8o","svgSpinner":"svgSpinner_bbV30YFg","errorLink":"errorLink_vs9Kuxis","errorColour":"errorColour_fmRwMJhw"};